import { Linkedin, Mail, Rss, User } from 'lucide-react';

export function getSourceIcon(source: string) {
  switch (source) {
    case 'linkedin':
      return <Linkedin className='h-4 w-4' />;
    case 'email':
      return <Mail className='h-4 w-4' />;
    case 'rss':
      return <Rss className='h-4 w-4' />;
    case 'manual':
      return <User className='h-4 w-4' />;
    default:
      return <Mail className='h-4 w-4' />;
  }
}
